<app-base-widget [cardClass]="'bg-white'">
    <mat-tab-group animationDuration="0" (selectedTabChange)="handleChange($event)">
        @for (tab of visibleTabs(); track tab.id) {
            <mat-tab>
                <ng-template mat-tab-label>
                    <div header class="flex">{{tab.label}}
                        <app-info-icon tooltipPosition="above"
                            [tooltipInfo]="tab.tooltip"
                            [attr.data-cy]="tab.tooltipDataCy" tooltipClass="info-icon-top-8">
                        </app-info-icon>
                    </div>
                </ng-template>
                <ng-template matTabContent>
                    <app-base-widget [error]="tab.error" [card]="false" [attr.data-cy]="tab.chartDataCy">
                        <app-gcm-chart [chartStyle]="chartStyle" chartType="bar" [chartOptions]="tab.chartOptions">
                        </app-gcm-chart>
                    </app-base-widget>
                </ng-template>
            </mat-tab>
        }
    </mat-tab-group>
</app-base-widget>
